module.exports = __webpack_public_path__ + "static/media/edit-dark.86fd008d.svg";